/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PublicLeak } from './PublicLeak';
import {
    PublicLeakFromJSON,
    PublicLeakFromJSONTyped,
    PublicLeakToJSON,
    PublicLeakToJSONTyped,
} from './PublicLeak';

/**
 * 
 * @export
 * @interface PaginatedPublicLeakList
 */
export interface PaginatedPublicLeakList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedPublicLeakList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPublicLeakList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPublicLeakList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<PublicLeak>}
     * @memberof PaginatedPublicLeakList
     */
    results: Array<PublicLeak>;
}

/**
 * Check if a given object implements the PaginatedPublicLeakList interface.
 */
export function instanceOfPaginatedPublicLeakList(value: object): value is PaginatedPublicLeakList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedPublicLeakListFromJSON(json: any): PaginatedPublicLeakList {
    return PaginatedPublicLeakListFromJSONTyped(json, false);
}

export function PaginatedPublicLeakListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedPublicLeakList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(PublicLeakFromJSON)),
    };
}

  export function PaginatedPublicLeakListToJSON(json: any): PaginatedPublicLeakList {
      return PaginatedPublicLeakListToJSONTyped(json, false);
  }

  export function PaginatedPublicLeakListToJSONTyped(value?: PaginatedPublicLeakList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(PublicLeakToJSON)),
    };
}

